import React from 'react';
import { Box, Collapse, Typography } from '@mui/material';
import type { Edge, Node } from 'reactflow';
import BlobInput from './BlobInput';

function getSourceNodeText(
  nodes: Node[],
  sourceId: string | undefined,
): string {
  if (!sourceId) return '';
  const src = nodes.find(n => n.id === sourceId);
  const text = (src?.data as Record<string, unknown>)?.text;
  const output = (src?.data as Record<string, unknown>)?.output;
  if (typeof text === 'string') return text;
  if (typeof output === 'string') return output;
  return '';
}

export default function NodeConfigBlobSection({
  blobOpen,
  onToggle,
  blobConfig,
  onChange,
  parseError,
  nodeId,
  edges,
  findColor,
  nodes,
}: {
  blobOpen: boolean;
  onToggle: () => void;
  blobConfig: string;
  onChange: (value: string) => void;
  parseError?: string | null;
  nodeId?: string;
  edges?: Edge[];
  findColor?: { color: string };
  nodes?: Node[];
}) {
  const blobEdges = (edges ?? []).filter(
    e => e.target === nodeId && e.targetHandle === 'blobConfig',
  );
  const dataConnected =
    nodes && nodes.length > 0
      ? blobEdges.map(e => ({
          id: e.source ?? '',
          text: getSourceNodeText(nodes, e.source),
        }))
      : blobEdges.map(e => ({
          id: e.source ?? '',
          text: blobConfig,
        }));
  const isActiveBlobHandle = nodeId != null && blobEdges.length > 0;
  return (
    <Box sx={{ mt: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
        <Typography
          sx={{
            fontSize: '12px',
            color: '#98A2B3',
            cursor: 'pointer',
            textDecoration: 'underline',
          }}
          onClick={onToggle}
        >
          {blobOpen ? 'Hide' : 'Show'} node config (JSON)
        </Typography>
      </Box>
      <Collapse in={blobOpen}>
        <BlobInput
          value={blobConfig}
          onChange={onChange}
          parseError={parseError}
          nodeId={nodeId}
          handleId="blobConfig"
          dataConnected={dataConnected}
          isActive={!!isActiveBlobHandle}
          findColor={findColor}
        />
      </Collapse>
    </Box>
  );
}
